const topbar = {
    docs: 'Docs',
    help: 'ช่วยเหลือ',
    subscription: 'การสมัครสมาชิก',
};
export default Object.freeze(topbar);
